import { SkuSearch, SkuSearchResult } from "@/types/Sku";
import { adminBaseQueryWrapper } from "@/utils/rtkHelper";
import { createApi } from "@reduxjs/toolkit/query/react";
import { StockReportResult,StockReport} from "@/types/OrderItem";
interface SkuResponse {
  description: string;
  sku_id: string;
  unit: string;
  hsn_code: string;
  tex_pre: string;
  user_id: number;
  category_id: number;
  sub_category_id: number;
  selling_price: number;
  selling_account_id: number;
  purchase_cost_price: number;
  purchase_account_id: number;
  document_id: number;
  id: number;
}

export const skuAllCompanyApi = createApi({
  reducerPath: "skuAllCompanyApi",
  baseQuery: adminBaseQueryWrapper,
  tagTypes: ["sku"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    // searchSku: builder.query<SkuSearchResult, SkuSearch>({
    //   query: ({ search }) => {
    //     const params = new URLSearchParams();
    //     if (search && search.length > 0) {
    //       params.set("search", search);
    //     }
    //     return `/sku?${params.toString()}`;
    //   },
    //   providesTags: ["sku"],
    // }),
    getItemBySkuId: builder.query({
      query: (id) => `/sku/item/${id}`,
      providesTags: ["sku"],
    }),

    getAllSku: builder.query<SkuResponse[], any>({
      query: () => `/sku`,
      providesTags: ["sku"],
    }),
    searchSku: builder.query<SkuSearchResult, SkuSearch>({
      query: (input) => ({
        url: `/sku/search-get`,
        method: "POST",
        body: { ...input, export: false },
      }),
      providesTags: ["sku"],
    }),
    exportSku: builder.mutation<Blob, SkuSearch>({
      query: (input) => ({
        url: `/sku/search`,
        method: "POST",
        body: { ...input, export: true },
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
    getSkuById: builder.query<any, any>({
      query: ({ id }) => `/sku/${id}`,
      providesTags: ["sku"],
    }),
    createSku: builder.mutation<void, any>({
      query: (input) => ({
        url: `/sku`,
        method: "POST",
        body: input,
      }),
      invalidatesTags: ["sku"],
    }),
    updateSku: builder.mutation<void, { id: string; data: any }>({
      query: ({ id, data }) => ({
        url: `/sku/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["sku"],
    }),
    deleteSku: builder.mutation<void, any>({
      query: ({ id }) => ({
        url: `/sku/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["sku"],
    }),
    uploadFile: builder.mutation({
      query: (formData) => ({
        url: `/sku/document`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["sku"],
    }),
    updateCostItem: builder.mutation({
      query: ({ cost_item_id, formData }) => ({
        url: `/cost-item/update/${cost_item_id}`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["sku"],
    }),
    getCostItemBySkuId: builder.query<any, any>({
      query: ({ sku_id }) => `/cost-item/by-sku/${sku_id}`,
      providesTags: ["sku"],
    }),
    deleteCostItem: builder.mutation({
      query: (cost_item_id) => ({
        url: `/cost-item/delete/${cost_item_id}`,
        method: "DELETE",
      }),
    }),
    getSkuByID: builder.query<any, any>({
      query: ({ sku_id }) => `/sku/${sku_id}`,
      providesTags: ["sku"],
    }),

    getStockReport: builder.query<StockReportResult, StockReport>({
          query: (input) => ({
            url: `/sku/stock/stock_report`,
            method: "POST",
            body: input,
          }),
        }),

    // getSubCategory: builder.query<any, { categoryId: number; search: string }>({
    //   query: ({ categoryId, search }) => {
    //     const params = new URLSearchParams();
    //     console.log(search);
    //     if (search && search.length > 0) {
    //       params.set("search", search);
    //     }
    //     return `/subcategory/list/${categoryId}?${params.toString()}`;
    //   },
    //   providesTags: ["sku"],
    // }),

    // getSubCategoryById: builder.query<any, any>({
    //   query: (id) => `/subcategory/${id}`,
    //   providesTags: ["sku"],
    // }),

    // createSubCategory: builder.mutation<void, any>({
    //   query: (input) => ({
    //     url: `/subcategory`,
    //     method: "POST",
    //     body: input,
    //   }),
    //   invalidatesTags: ["sku"],
    // }),
    // updateSubCategory: builder.mutation<void, any>({
    //   query: ({ id, data }) => ({
    //     url: `/subcategory/${id}`,
    //     method: "PUT",
    //     body: data,
    //   }),
    //   invalidatesTags: ["sku"],
    // }),
    // deleteSubCategory: builder.mutation<void, number>({
    //   query: (id) => ({
    //     url: `/subcategory/${id}`,
    //     method: "DELETE",
    //   }),
    //   invalidatesTags: ["sku"],
    // }),
  }),
});

export const {
  useCreateSkuMutation,
  useGetItemBySkuIdQuery,
  useLazyGetItemBySkuIdQuery,
  useDeleteSkuMutation,
  useGetSkuByIdQuery,
  useSearchSkuQuery,
  useLazySearchSkuQuery,
  useExportSkuMutation,
  useUpdateSkuMutation,
  useGetAllSkuQuery,
  useUploadFileMutation,
  useUpdateCostItemMutation,
  useGetCostItemBySkuIdQuery,
  useDeleteCostItemMutation,
  useLazyGetSkuByIDQuery,
  useGetStockReportQuery
} = skuAllCompanyApi;
